export default "__VITE_ASSET__BHUAxBaB__"